import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { serviceRegistry } from './services/ServiceRegistry'
import { store } from './store'
import { Provider } from 'react-redux'
import * as serviceWorkerRegistration from './sw-registration'

serviceRegistry.initServices()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)

// This build does not generate a service worker. Remove registrations left by
// older releases so clients receive the current bundle after their next load.
serviceWorkerRegistration.unregister()
